export { SpecsIcon } from './specs'
